import React from "react";
import { DisclosureCallbacks } from "./use-disclosure";
import { useDisclosureDebounce } from "./use-disclosure-debounce";
import { breakpoints } from "./use-breakpoints";

export const isBreakpoint = (breakpoint: number | keyof typeof breakpoints) => {
  const bp =
    typeof breakpoint == "string" ? breakpoints[breakpoint] : breakpoint;
  return window.innerWidth >= bp;
};
export default function useBreakpoint(
  breakpoint: number | keyof typeof breakpoints,
  debounce: number = 100,
  callbacks?: DisclosureCallbacks,
) {
  const bp =
    typeof breakpoint == "string" ? breakpoints[breakpoint] : breakpoint;
  const ret = useDisclosureDebounce(window.innerWidth >= bp, callbacks);
  const [value, actions] = ret;
  React.useEffect(() => {
    actions.debounce.set(debounce, window.innerWidth >= bp);
  }, [bp]);
  React.useEffect(() => {
    const handler = () =>
      actions.debounce.set(debounce, window.innerWidth >= bp);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [value, bp]);
  return ret[0];
}
